import { render, staticRenderFns } from "./ModalCreateInmo.vue?vue&type=template&id=8a8284d2"
import script from "./ModalCreateInmo.vue?vue&type=script&lang=js"
export * from "./ModalCreateInmo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports